import React, { useContext, useRef, useState, useEffect } from "react"
import { DataContext } from "./crossfilter-context"
import dc from "dc"

export const ChartTemplate = props => {
  /*
  We render the dc chart using an effect. We want to pass the chart as a prop after the dc call,
  but there is nothing by default to trigger a re-render and the prop, by default would be undefined.
  To solve this, we hold a state key and increment it after the effect ran.
  By passing the key to the parent div, we get a rerender once the chart is defined.
  */
  const context = useContext(DataContext)
  const [chart, setChartOnState] = useState(null)
  const { data } = context
  const ndx = data.data
  const div = useRef(null)
  useEffect(() => {
    const newChart = props.chartFunction(div.current, ndx) // chartfunction takes the ref and does something with it

    newChart.render()
    setChartOnState(newChart)
  }, 1)

  return (
    <div
      ref={div}
      style={{ width: "100%", minHeight: "100%" }}
      {...props.styles}
    ></div>
  )
}
